export default "__VITE_ASSET__6d3lkHKf__"